import { render, staticRenderFns } from "./WorkPlanBoard.vue?vue&type=template&id=d0d6c118&"
import script from "./WorkPlanBoard.vue?vue&type=script&lang=ts&"
export * from "./WorkPlanBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports